import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
    ResultInterface,
    ResultPreviewDataInterface,
    ResultPreviewInterface,
    ResultUploadConfirmInterface,
    ResultUploadUrlPostInterface,
    ResultUploadUrlResponseInterface,
} from "../../interfaces";

@Injectable({
    providedIn: "root",
})
export class ResultService {
    constructor(private httpClient: HttpClient) {}

    create(data: FormData): Observable<{ data: ResultInterface }> {
        return this.httpClient.post<{ data: ResultInterface }>(environment.API_URL + "/app/results/create/", data);
    }

    deleteResult(id: string): Observable<any> {
        return this.httpClient.delete<any>(environment.API_URL + `/app/results/${id}/`);
    }

    preview(data: ResultPreviewInterface): Observable<ResultPreviewDataInterface> {
        return this.httpClient.post<ResultPreviewDataInterface>(
            environment.API_URL + "/app/results/upload-preview/",
            data,
        );
    }

    generateUploadUrl(
        data: ResultUploadUrlPostInterface,
    ): Observable<{ responses: ResultUploadUrlResponseInterface[] }> {
        return this.httpClient.post<{ responses: ResultUploadUrlResponseInterface[] }>(
            environment.API_URL + "/app/results/presign-upload/",
            data,
        );
    }

    uploadToPresignedUrl(uploadUrl: string, file: File) {
        const headers = new HttpHeaders({
            "Content-Type": file.type || "application/octet-stream",
            "Skip-Auth": "true",
        });
        return this.httpClient.put(uploadUrl, file, {
            headers,
            // reportProgress: true,
            // observe: "events",
            responseType: "text",
        });
    }

    confirmResultUpload(data: ResultUploadConfirmInterface): Observable<any> {
        return this.httpClient.post<any>(environment.API_URL + "/app/results/confirm-upload/", data);
    }

    getResult(id: string): Observable<ResultInterface> {
        return this.httpClient.get<ResultInterface>(environment.API_URL + `/app/results/${id}/`);
    }

    downloadResult(id: string): Observable<{ download_url: string }> {
        return this.httpClient.get<{ download_url: string }>(environment.API_URL + `/app/results/download/${id}/`);
    }
}
